module.exports = __webpack_public_path__ + "static/img/jiaZhiBottom.3d7ca02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jiaZhiBottom.png
// module id = fVjj
// module chunks = 2